<script lang="ts">
	interface Props {
		className?: string;
	}

	let { className = '' }: Props = $props();
</script>

<div class={className}>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		stroke="currentColor"
		fill="none"
		stroke-width="1"
	>
		<path
			fill="transparent"
			d="M12 1.5c5.799 0 10.5 4.701 10.5 10.5S17.799 22.5 12 22.5 1.5 17.799 1.5 12 6.201 1.5 12 1.5Z"
		></path>
		<path
			fill="currentColor"
			stroke-width="0"
			d="M12 15.938a.984.984 0 1 1 0 1.968.984.984 0 0 1 0-1.968Zm.154-10.172c2.077 0 3.127 1.57 3.127 3.126 0 .968-.412 1.834-1.523 2.944-.879.879-1.102 1.318-1.102 1.805v.656a.656.656 0 1 1-1.312 0v-.656c0-.877.38-1.628 1.486-2.733.88-.88 1.139-1.424 1.139-2.016 0-.916-.6-1.814-1.815-1.814-1.366 0-2.123.864-2.123 1.814a.656.656 0 1 1-1.312 0c0-1.64 1.303-3.126 3.435-3.126Z"
		></path>
	</svg>
</div>
